import { render, staticRenderFns } from "./GateLockDamage.vue?vue&type=template&id=d1815566&scoped=true"
import script from "./GateLockDamage.vue?vue&type=script&lang=ts"
export * from "./GateLockDamage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1815566",
  null
  
)

export default component.exports